const styles = {
  listItemMainText: {
    color: 'neutral.main',
  },
  listItemSecondaryText: {
    color: 'neutral.light',
  },
}

export default styles
